export default apiFetch => async payload => {
  const response = await apiFetch({
    endpoint: "talktous",
    method: "post",
    body: payload
  });

  return await response.json();
};
